<template>
    <e-charts
        :options="chartOptions"
        :init-options="initOptions"
        ref="map"
        autoresize
    />
</template>
<script>
import barMixin from '@/views/common/m-chart-line'

// 合约到期
export default {
    mixins: [barMixin],
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        times: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        chartOptions() {
            var color = ['#F29494']

            return {
                title: {
                    text: '单位: 间',
                    textStyle: {
                        color: '#999',
                        fontSize: 12,
                    },
                },
                tooltip: {},
                legend: {
                    show: false,
                },
                grid: {
                    top: 28,
                    left: 0,
                    right: 10,
                    bottom: 0,
                    containLabel: true,
                },
                yAxis: {
                    type: 'value',
                    splitNumber: 3,
                    boundaryGap: [0, 0.01],
                    axisLine: {
                        lineStyle: {
                            color: '#F2F2F2',
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        color: '#999',
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#F2F2F2',
                            type: 'dashed',
                        },
                    },
                },
                xAxis: {
                    type: 'category',
                    data: this.times,
                    axisLine: {
                        lineStyle: {
                            color: '#F2F2F2',
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        color: '#999',
                        rotate: 45,
                    },
                    splitLine: {
                        show: false,
                    },
                },
                series: [
                    {
                        name: '到期数',
                        type: 'line',
                        label: {
                            show: true,
                            fontSize: 10,
                        },
                        data: this.value,
                        symbol: 'circle',
                        symbolSize: 8,
                    },
                ],
                color,
            }
        },
    },
}
</script>
